




























































import { Component, Vue } from "vue-property-decorator";
import { AuthApi } from "@/services/api-service";
import { SetPasswordBody } from "@/api/api";
import AuthModule from "@/store/auth";
import { EditStatus } from "@/types";
import FormModal from "./FormModal.vue";

@Component({
  components: {
    FormModal,
  },
})
export default class CResetPasswordForm extends Vue {
  private get editStatus() {
    return EditStatus;
  }

  private get setPasswordStatus() {
    return AuthModule.setPasswordStatus;
  }

  private mounted() {
    AuthModule.commitSetPasswordStatus(EditStatus.Edit);
  }

  private form: SetPasswordBody = {
    password: "",
    confirmPassword: "",
  };

  private confirm() {
    AuthModule.commitSetPasswordStatus(EditStatus.Confirm);
    window.scrollTo(0, 0);
  }

  private async submit() {
    const { token } = this.$route.query;
    const authApi = AuthApi.createInstance(token as string);
    try {
      await authApi.setUserPassword(this.form);
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  }

  private backEdit() {
    AuthModule.commitSetPasswordStatus(EditStatus.Edit);
    window.scrollTo(0, 0);
  }

  // ここからモーダル//
  private testShow() {
    (this.$refs.test as FormModal).CtestShow();
    this.submit();
  }
  // ここまでモーダル//
}
